export const AssertionSentences = {
  Default: {
    LABEL: "Твердження",
    ASSERTION_PLACEHOLDER: "Твердження",
    ADD_ASSERTION_TEXT: "Додати твердження",
  },
};
